// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__shPV4","list":"MainNavigation_list__2Jc3V","active":"MainNavigation_active__vEF95"};